import React, { useEffect } from 'react';
import Auth from "./sdk/Auth";
import CaseReport from './CaseReport'

const LoginOK = () => {
    useEffect(() => {
        Auth.setNextTokenRefresh()
    }, []);

    return (
        <div>
            <CaseReport />
        </div>
      );
};

export default LoginOK;
